import vInputComponent from './input/vInput.vue'

const jphUi = {
  install (Vue) {
    Vue.component('vInput', vInputComponent)
  }
}

export default jphUi



// WEBPACK FOOTER //
// ./src/libs/ui/index.js